<template>
  <section class="vacancy-content">
    <BreadCrumb />
    <div class="container">
      <div class="vacancy-heading">
        <h2 class="font-34 uppercase pangram-black">
          {{ _.get(contentData, "conf.header.title") }}
        </h2>
        <p class="teaser font-16 bold lh-32">
          {{ _.get(contentData, "conf.header.teaser") }}
        </p>
      </div>
      <section class="vacancy-list">
        <div class="list-heading">
          <p class="font-16 bold uppercase vacancy-position">
            {{ $fn.tr("პოზიცია") }}
          </p>
          <div class="date">
            <p class="font-16 bold uppercase vacancy-publish-date">
              {{ $fn.tr("გამოქვეყნების დრო") }}
            </p>
            <p class="font-16 bold uppercase vacancy-end-date">
              {{ $fn.tr("დასრულების დრო") }}
            </p>
          </div>
        </div>
        <div class="list-content">
          <!-- vacancyList -->
          <!-- {{ _.get(contentData, "data.list") }} -->
          <template v-for="(item, index) in vacancyList">
            <router-link
              :to="$store.getters['main/getSingleUrl'](item)"
              tag="a"
              class="single-element"
              :key="index"
            >
              <p class="font-16 bold vacancy-position">{{ item.title }}</p>
              <div class="date">
                <p class="font-16 bold vacancy-publish-date">
                  {{ $moment(item.startDate).format("DD MMMM") }}
                </p>
                <p class="date-arrow">-</p>
                <p class="font-16 bold vacancy-end-date">
                  {{ $moment(item.endDate).format("DD MMMM") }}
                </p>
              </div>

              <div class="vacancy-visit">
                <p class="font-16 bold ">{{ $fn.tr("ვიზიტი") }}</p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7.857"
                  height="10"
                  viewBox="0 0 7.857 10"
                >
                  <path
                    id="Icon_material-play-arrow"
                    data-name="Icon material-play-arrow"
                    d="M12,7.5v10l7.857-5Z"
                    transform="translate(-12 -7.5)"
                    fill="#4d4d4f"
                  />
                </svg>
              </div>
            </router-link>
          </template>
        </div>
      </section>
      <div class="mall-pagination-container" v-if="list_count > per_page_count">
        <el-pagination
          class="pagination mall-pagination container"
          layout="prev,pager, next"
          :page-size="per_page_count"
          :current-page.sync="page"
          :total="list_count"
          :disabled="false"
          :hide-on-single-page="true"
          @current-change="sendData"
          :key="'pagination'"
        />
      </div>
    </div>
  </section>
</template>
<script>
import fn from "../../helpers/func";
import BreadCrumb from "@/components/modules/BreadCrumb";
export default {
  props: ["contentData"],
  components: {
    BreadCrumb
  }, 
  data() {
    return {
      page: 1,
      _list_count: null,
      filteredList: null
    };
  },
  computed: {
    vacancyList() {
      if (this.filteredList) {
        return this.filteredList;
      } else {
        return _.get(this.contentData, "data.list");
      }
    },
    per_page_count() {
      return parseInt(_.get(this.contentData, "conf.page_count"))
        ? parseInt(_.get(this.contentData, "conf.page_count"))
        : 8;
    },
    get_unic_id() {
      return _.get(this.contentData, "conf.unicId");
    },
    list_count() {
      if (this.filteredList) {
        return this._list_count;
      } else {
        return _.get(this.contentData, "data.listCount");
      }
    }
  },
  methods: {
    async sendData() {
      const params = {
        componentUnicId: this.get_unic_id,
        id: _.get(this.$store.state.main.selected_menu, "id"),
        pageNumber: this.page,
        perPage: this.per_page_count
      };
      const res = await fn.postData("main/getDataList", params);
      window.scrollTo({ top: 0, behavior: "smooth" });

      this.filteredList = res.data.list || null;
      this._list_count = res.data.listCount;
    }
  },
  watch: {
    per_page_count(ns, os) {
      this.$store.commit("main/setState", {
        key: "per_page",
        val: ns
      });
    },
    get_unic_id: {
      immediate: true,
      handler(ns, os) {
        if (ns)
          this.$store.commit("main/setState", {
            key: "unique_id",
            val: ns
          });
      }
    }
  }
};
</script>
<style lang="scss">
.vacancy-content {
  // padding-top: 55px;
  padding-bottom: 89px;
  background: $dirtywhite;
  @media (max-width: 767px) {
    padding-bottom: 55px;
  }
  .mall-pagination-container {
    padding-bottom: 0;
  }
  .mall-pagination {
    padding: 0;
  }
  .vacancy-heading {
    h2 {
      margin-bottom: 34px;
    }
    .teaser {
      color: $lightGray2;
      max-width: 80%;
      @media (max-width: 767px) {
        max-width: 100%;
      }
    }
  }
  .vacancy-list {
    margin-top: 55px;
    .list-heading {
      display: flex;
      background: #d1d1d1;
      padding: 36px 30px;
      p {
        color: $black;
      }
      @media (max-width: 1023px) {
        display: none;
      }
    }
    .list-content {
      .single-element {
        display: flex;
        padding: 36px 30px;
        position: relative;
        background: $dirtywhite;
        transition: 0.4s ease-in-out;
        border-top: 1px solid rgba(26, 26, 26, 0.1);
        &:last-child {
          border-bottom: 1px solid rgba(26, 26, 26, 0.1);
        }
        &:hover {
          background: $white;
          transition: 0.4s ease-in-out;
        }
        p {
          color: $lightGray2;
        }
        .date-arrow {
          display: none;
          @media (max-width: 1023px) {
            display: block;
            margin: 0 10px;
          }
        }
        .vacancy-visit {
          top: 50%;
          right: 20px;
          display: none;
          position: absolute;
          align-items: center;
          transform: translateY(-50%);
          @media (max-width: 1023px) {
            display: flex;
          }
          @media (max-width: 767px) {
            position: unset;
            transform: translateY(0);
            top: 0%;
            right: unset;
            margin-top: 20px;
          }
          p {
            margin-right: 10px;
          }
        }
        @media (max-width: 1023px) {
          padding: 21px 0;
          flex-direction: column;
          padding-right: 130px;
        }
        @media (max-width: 767px) {
          padding-right: 0;
        }
      }
    }
    .vacancy-position {
      max-width: calc(60% - 30px);
      width: 100%;
      margin-right: 30px;
      @media (max-width: 1023px) {
        max-width: 100%;
        margin-bottom: 20px;
        font-size: 21px;
      }
      @media (max-width: 767px) {
        font-size: 16px;
      }
    }
    .date {
      width: 100%;
      display: flex;
      max-width: 40%;
      justify-content: space-between;
      @media (max-width: 1023px) {
        justify-content: flex-start;
        max-width: 100%;
      }
    }
    .vacancy-publish-date {
      width: calc(50% - 30px);
      @media (max-width: 1023px) {
        width: fit-content;
      }
      @media (max-width: 767px) {
        font-size: 13px;
      }
    }
    .vacancy-end-date {
      width: calc(50% - 30px);
      @media (max-width: 1023px) {
        width: fit-content;
      }
      @media (max-width: 767px) {
        font-size: 13px;
      }
    }
  }
}
</style>
